module.exports = __webpack_public_path__ + "img/text-nachnahme.f1b58617.png";